export const adminFieldsList = {
  fields: [
    {
      name: '__slot:icon',
      width: '25px',
      dataClass: 'text-center',
    },
    {
      name: 'employee_name',
      title: 'Employee',
      sortField: 'employee_name',
      width: '22%',
    },
    {
      name: 'manager_name',
      title: 'Manager',
      sortField: 'manager_name',
      width: '23%',
    },
    {
      name: 'organisation_name',
      title: 'Organisation',
      sortField: 'organisation_name',
      width: '20%',
    },
    {
      name: 'period',
      title: 'Period',
      sortField: 'start',
      width: '20%',
    },
    {
      name: 'days',
      title: 'Days',
      width: '5%',
    },
    {
      name: '__slot:actions',
      dataClass: 'text-right',
    },
  ],
}

export const managerFieldsList = {
  fields: [
    {
      name: '__slot:icon',
      width: '25px',
      dataClass: 'text-center',
    },
    {
      name: 'employee_name',
      title: 'Employee',
      sortField: 'employee_name',
      width: '22%',
    },
    {
      name: 'manager_name',
      title: 'Manager',
      sortField: 'manager_name',
      width: '23%',
    },
    {
      name: 'organisation_name',
      title: 'Organisation',
      sortField: 'organisation_name',
      width: '20%',
    },
    {
      name: 'period',
      title: 'Period',
      sortField: 'start',
      width: '20%',
    },
    {
      name: 'days',
      title: 'Days',
      width: '5%',
    },
    {
      name: '__slot:actions',
      dataClass: 'text-right',
    },
  ],
}

export const employeeFieldsList = {
  fields: [
    {
      name: '__slot:icon',
      width: '25px',
      dataClass: 'text-center',
    },
    {
      name: 'manager_name',
      title: 'Manager Name',
      sortField: 'manager_name',
      width: '30%',
    },
    {
      name: 'organisation_name',
      title: 'Organisation',
      sortField: 'organisation_name',
      width: '25%',
    },
    {
      name: 'period',
      title: 'Period',
      sortField: 'start',
      width: '25%',
    },
    {
      name: 'days',
      title: 'Total Days',
      width: '15%',
    },
  ],
}
